import { makeClassName } from '@siteless/util';
import React from 'react';
import optionTypes from '../../resources/Ballot/constants/optionTypes';

const OptionComponent = ({
  className,
  type,
  title,
  displayPoints,
  details,
  isSelected,
  onClick,
  faded,
}: {
  className?: string;
  type: (typeof optionTypes)[keyof typeof optionTypes];
  title: string;
  displayPoints: string;
  details?: string;
  isSelected?: boolean;
  onClick: () => void;
  faded?: boolean;
}) => (
  <div
    className={makeClassName(
      'OptionComponent',
      'flex h-full min-h-0 w-full flex-col overflow-hidden rounded-2xl bg-neutral-100',
      className,
      isSelected && '--selected',
      faded && '--faded',
    )}
    onClick={onClick}
  >
    <div className="mb-1 flex w-full min-w-0 flex-none overflow-hidden font-medium">
      <type.Icon className="mr-2 flex-none" />
      <span className="min-w-0 flex-1 truncate">{title}</span>
    </div>
    <div className="__points mb-1">{displayPoints}</div>
    <div className="__details overflow-hidden text-ellipsis">{details}</div>
  </div>
);

export default OptionComponent;
